export const COMMON_NAMES = [
    'BOB', 'JIM', 'TOM', 'JOE', 'BILL', 'DAN', 'KEN', 'PAT', 'MIKE', 'DAVE',
    'ED', 'DON', 'AL', 'RON', 'JAY', 'RAY', 'LEE', 'VIC', 'SAM', 'BEN',
    'ANN', 'SUE', 'KAY', 'JAN', 'PAM', 'LIZ', 'MEG', 'AMY', 'JOY', 'EVA',
    'ART', 'HAL', 'REX', 'GUY', 'NED', 'ROY', 'TED', 'VIC', 'WES', 'ZAC',
    "TIM", "MAX", "IAN", "JON", "KIM", "LEO", "REX", "VAN",
    "CAL", "DOC", "ELI", "FOX", "GIL", "HUE", "IRA", "JED", "KIP", "LEN",
    "MAC", "NAT", "OLE", "PIP", "RIP", "SAL", "TAD", "VAL", "ASH", "BUD",
    "CAM", "DAX", "FAY", "GUS", "HANK", "IVY", "LOU", "NAN", "ORA", "QUINN",
    "ROB", "TEX", "UNA", "VIV", "WIL", "YEN", "ZOE", "BEA", "CAT", "DEB",
    "EVE", "FLO", "GAY", "HOPE", "IRIS", "KIT", "MAY"
];

export const LOCATIONS = [
    { city: 'NEW YORK', state: 'NY', country: 'US', region: 'US' },
    { city: 'BOSTON', state: 'MA', country: 'US', region: 'US' },
    { city: 'MIAMI', state: 'FL', country: 'US', region: 'US' },
    { city: 'DALLAS', state: 'TX', country: 'US', region: 'US' },
    { city: 'LOS ANGELES', state: 'CA', country: 'US', region: 'US' },
    { city: 'CHICAGO', state: 'IL', country: 'US', region: 'US' },
    { city: 'SEATTLE', state: 'WA', country: 'US', region: 'US' },
    { city: 'DENVER', state: 'CO', country: 'US', region: 'US' },
    { city: 'PHOENIX', state: 'AZ', country: 'US', region: 'US' },
    { city: 'ATLANTA', state: 'GA', country: 'US', region: 'US' },
    { city: 'LONDON', state: '', country: 'UK', region: 'UK' },
    { city: 'PARIS', state: '', country: 'FRANCE', region: 'FR' },
    { city: 'TOKYO', state: '', country: 'JAPAN', region: 'JP' },
    { city: 'BERLIN', state: '', country: 'GERMANY', region: 'DE' },
    { city: 'ROME', state: '', country: 'ITALY', region: 'IT' },
    { city: 'TORONTO', state: 'ON', country: 'CANADA', region: 'CA' },
    { city: 'SYDNEY', state: 'NSW', country: 'AUSTRALIA', region: 'AU' },
    { city: 'MOSCOW', state: '', country: 'RUSSIA', region: 'RU' },
    { city: 'MADRID', state: '', country: 'SPAIN', region: 'ES' },
    { city: 'OSLO', state: '', country: 'NORWAY', region: 'NO' },
    { city: 'ST PAUL', state: 'MN', country: 'US', region: 'US' },
    { city: 'RIO DE JANEIRO', state: '', country: 'BRAZIL', region: 'SA' },
    { city: 'BUENOS AIRES', state: '', country: 'ARGENTINA', region: 'SA' },
    { city: 'CAPE TOWN', state: '', country: 'SOUTH AFRICA', region: 'AF' },
    { city: 'CAIRO', state: '', country: 'EGYPT', region: 'AF' },
    { city: 'BEIJING', state: '', country: 'CHINA', region: 'AS' },
    { city: 'MUMBAI', state: '', country: 'INDIA', region: 'AS' },
    { city: 'AUCKLAND', state: '', country: 'NEW ZEALAND', region: 'OC' },
    { city: 'MCMURDO', state: '', country: 'ANTARCTICA', region: 'AN' },
    { city: 'SEOUL', state: '', country: 'SOUTH KOREA', region: 'AS' },
    { city: 'JAKARTA', state: '', country: 'INDONESIA', region: 'AS' },
    { city: 'MEXICO CITY', state: '', country: 'MEXICO', region: 'NA' },
    { city: 'LIMA', state: '', country: 'PERU', region: 'SA' },
    { city: 'NASHVILLE', state: 'TN', country: 'US', region: 'US' },
    { city: 'PETALUMA', state: 'CA', country: 'US', region: 'US' },
    { city: 'BEVERLY HILLS', state: 'CA', country: 'US', region: 'US' },
    { city: 'CIMARRON', state: 'NM', country: 'US', region: 'US' },
    { city: 'AMMAN', state: '', country: 'JORDAN', region: 'AS' },
    { city: 'NEW DELHI', state: '', country: 'INDIA', region: 'AS' },
    { city: 'TETIAROA', state: '', country: 'TAHITI', region: 'OC' },
    { city: 'ISS', state: '', country: 'SPACE', region: 'DX' }
];

export const WEATHER_CONDITIONS = [
    'SUNNY', 'RAINING', 'CLOUDY', 'COLD', 'HOT', 'WINDY', 'SNOWING',
    'FOGGY', 'NICE', 'WARM', 'STORM', 'CLEAR', 'HUMID', 'DRY'
];

export const RIGS = [
    'ICOM 7300', 'YAESU FT891', 'K3', 'FLEX 6400', 'TS590',
    'FTDX10', 'IC705', 'KX3', 'KX2', 'FT817',
    'HOMEBREW', 'VINTAGE', 'QRP RIG', '100W RIG',
    'XIEGU G90', 'YAESU FTX-1', 'QMX', 'IC7610', 'FTDX101', 'SUN SDR'
];

export const ANTENNAS = [
    'DIPOLE', 'YAGI', 'VERTICAL', 'EFHW', 'LOOP',
    'LONG WIRE', 'BEAM', 'WHIP', 'G5RV', 'FAN DIPOLE'
];

export const RST_REPORTS = [
    '599', '579', '559', '449', '339', '589', '569'
];

export const HOBBIES = [
    'GARDENING', 'FISHING', 'HIKING', 'SAILING', 'WOODWORKING', 'READING',
    'CHESS', 'COOKING', 'PHOTOGRAPHY', 'ASTRONOMY', 'GOLF', 'BIRD WATCHING',
    'GEOCACHING', 'MODEL TRAINS', 'HAM RADIO', 'CYCLING', 'RUNNING', 'PAINTING'
];

export const PROFESSIONS = [
    'ENGINEER', 'PILOT', 'TEACHER', 'DOCTOR', 'MECHANIC', 'FARMER',
    'SOFTWARE DEV', 'ELECTRICIAN', 'TRUCK DRIVER', 'SCIENTIST', 'WRITER', 'NAVY VET',
    'PROFESSOR', 'ARCHITECT', 'POLICE', 'FIRE FIGHTER', 'MANAGER', 'RETIRED'
];

export const SHACK_DETAILS = [
    'HOT COFFEE', 'COLD BEER', 'MY CAT ON DESK', 'OLD TUBE RADIO',
    'LARGE WORLD MAP', 'LOTS OF QSL CARDS', 'MESSY BENCH', 'DUSTY RIG'
];

export const FAMOUS_HAMS = [
    // Celebrities & Historically Famous
    { call: 'WB6ACU', name: 'JOE', qth: 'LOS ANGELES, CA', hobby: 'GUITAR', profession: 'ROCK STAR', rig: 'TEN-TEC OMNI VII', ant: 'YAGI', num: '1970' },
    { call: 'W6XX', name: 'LEO', qth: 'PETALUMA, CA', hobby: 'PODCASTING', profession: 'TECH BROADCASTER', rig: 'ICOM 7300', ant: 'VERTICAL', num: '1010' },
    { call: 'KK6OTD', name: 'TIM', qth: 'LOS ANGELES, CA', hobby: 'CLASSIC CARS', profession: 'ACTOR', rig: 'YAESU FTDX101', ant: 'BEAM', num: '1990' },
    { call: 'KC4PV', name: 'PATTY', qth: 'EMORY, TX', hobby: 'SINGING', profession: 'COUNTRY SINGER', rig: 'ICOM 7610', ant: 'DIPOLE' },
    { call: 'WB4HHT', name: 'RONNIE', qth: 'NASHVILLE, TN', hobby: 'PIANO', profession: 'MUSICIAN', rig: 'KENWOOD TS990', ant: 'LOOP' },
    { call: 'N6YOS', name: 'PRISCILLA', qth: 'BEVERLY HILLS, CA', hobby: 'ACTING', profession: 'ACTRESS', rig: 'YAESU FT891', ant: 'WHIP' },
    { call: 'WA6BND', name: 'STEVE', qth: 'LOS GATOS, CA', hobby: 'ELECTRONICS', profession: 'ENGINEER', rig: 'HOMEBREW', ant: 'BEAM' },
    { call: 'K6AEP', name: 'GARRY', qth: 'LOS ANGELES, CA', hobby: 'DIRECTING', profession: 'PRODUCER', rig: 'ICOM 7300', ant: 'DIPOLE' },
    { call: 'N6NHG', name: 'KEVIN', qth: 'LAS VEGAS, NV', hobby: 'HACKING', profession: 'SECURITY', rig: 'FLEX 6400', ant: 'VERTICAL', num: '1337' },
    { call: 'W1AW', name: 'HIRAM', qth: 'NEWINGTON, CT', hobby: 'CODE PRACTICE', profession: 'ARRL HQ', rig: 'VINTAGE TUBE', ant: 'WIRE', num: '1' },
    { call: 'JY1', name: 'HUSSEIN', qth: 'AMMAN, JORDAN', hobby: 'DIPLOMACY', profession: 'KING', rig: 'YAESU FT1000', ant: 'YAGI' },
    { call: 'FO5GJ', name: 'MARLON', qth: 'TETIAROA, TAHITI', hobby: 'ISLAND LIFE', profession: 'ACTOR', rig: 'VINTAGE', ant: 'VERTICAL' },
    { call: 'WA4CCZ', name: 'CHET', qth: 'NASHVILLE, TN', hobby: 'FINGER PICKING', profession: 'GUITARIST', rig: 'VINTAGE TUBE', ant: 'WIRE' },
    { call: 'WA6SCD', name: 'DICK', qth: 'MALIBU, CA', hobby: '3D ANIMATION', profession: 'ACTOR', rig: 'ICOM 7300', ant: 'BEAM' },
    { call: 'VU2RG', name: 'RAJIV', qth: 'NEW DELHI, INDIA', hobby: 'FLYING', profession: 'PRIME MINISTER', rig: 'YAESU', ant: 'YAGI' },
    { call: 'NA1SS', name: 'ASTRO', qth: 'ISS, SPACE', hobby: 'SCIENCE', profession: 'ASTRONAUT', rig: 'KENWOOD', ant: 'EXTERNAL' },

    // YouTube Personalities & Community Leaders
    { call: 'K6UDA', name: 'BOB', qth: 'TWIN FALLS, ID', hobby: 'GOPRO VIDEOS', profession: 'YOUTUBER', rig: 'ICOM 7300', ant: 'VERTICAL', num: '1234' },
    { call: 'K8MRD', name: 'MIKE', qth: 'LADY LAKE, FL', hobby: 'POTA', profession: 'YOUTUBER', rig: 'YAESU FT891', ant: 'EFHW', num: '2345' },
    { call: 'KM4ACK', name: 'JASON', qth: 'JEFFERSONTOWN, KY', hobby: 'LINUX', profession: 'SOFTWARE DEV', rig: 'QMX', ant: 'VERTICAL', num: '3456' },
    { call: 'N4HNH', name: 'GEORGIA', qth: 'DECATUR, AL', hobby: 'HIKING', profession: 'YOUTUBER', rig: 'ICOM 705', ant: 'WHIP', num: '4567' },
    { call: 'AD0ND', name: 'DAVE', qth: 'BISMARCK, ND', hobby: 'EDUCATION', profession: 'TEACHER', rig: 'KENWOOD TS590', ant: 'YAGI', num: '1001' },
    { call: 'KI6NAZ', name: 'JOSH', qth: 'BIG BEAR, CA', hobby: 'COMMUNITY', profession: 'TECH HOST', rig: 'YAESU FTDX10', ant: 'VERTICAL', num: '4242' },
    { call: 'OH8STN', name: 'JULIAN', qth: 'FINLAND', hobby: 'SURVIVAL', profession: 'WRITER', rig: 'QRP RIG', ant: 'WIRE', num: '3650' },
    { call: 'W2AEW', name: 'ALAN', qth: 'FLORHAM PARK, NJ', hobby: 'TEST GEAR', profession: 'ENGINEER', rig: 'TEKTRONIX', ant: 'DIPOLE', num: '7300' },
    { call: 'VK3YE', name: 'PETER', qth: 'SYDNEY, NSW', hobby: 'BEACH RADIO', profession: 'AUTHOR', rig: 'HOMEBREW', ant: 'MAGNETIC LOOP', num: '3030' },
    { call: 'K4SWL', name: 'THOMAS', qth: 'SWANNANOA, NC', hobby: 'SHORTWAVE', profession: 'RADIOMAKER', rig: 'KX3', ant: 'EFHW', num: '7273' },
    { call: 'M0MCX', name: 'CALLUM', qth: 'LONDON', hobby: 'DX COMMANDER', profession: 'DESIGNER', rig: 'ICOM 7300', ant: 'VERTICAL', num: '5050' },
    { call: 'KC5HWB', name: 'JASON', qth: 'GRAPEVINE, TX', hobby: 'PODCASTING', profession: 'YOUTUBER', rig: 'ICOM 7300', ant: 'VERTICAL', num: '2020' },
    { call: 'KB9VBR', name: 'MICHAEL', qth: 'WAUSAU, WI', hobby: 'ANTENNAS', profession: 'YOUTUBER', rig: 'YAESU FT891', ant: 'SLIM JIM', num: '7388' },
    { call: 'W6JSV', name: 'JAY', qth: 'SAN FRANCISCO, CA', hobby: 'FIELD OPS', profession: 'ENGINEER', rig: 'ICOM 705', ant: 'WHIP', num: '0002' },
    { call: 'KF0KIF', name: 'MATT', qth: 'WAYNE, NE', hobby: 'POTA', profession: 'OP', rig: 'KX2', ant: 'WIRE', num: '0003' },
    // Other Notable Ops
    { call: 'N1CC', name: 'CHRIS', qth: 'KANAB, UT', hobby: 'CW', profession: 'OP', rig: 'ICOM 7610', ant: 'BEAM', num: '2022' },
    { call: 'K3LR', name: 'TIM', qth: 'WEST MIDDLESEX, PA', hobby: 'CONTESTING', profession: 'MANAGER', rig: 'FLEX 6700', ant: 'BEAM', num: '1500' },
    { call: 'W3LPL', name: 'FRANK', qth: 'GLENWOOD, MD', hobby: 'DXING', profession: 'PROFESSOR', rig: 'K3', ant: 'YAGI', num: '1501' },
    { call: 'VE9CF', name: 'STUART', qth: 'NEW BRUNSWICK, CA', hobby: 'QRP', profession: 'RETIRED', rig: 'KX3', ant: 'LOOP', num: '9999' },
    { call: 'K4HCO', name: 'MIKE', qth: 'FRONT ROYAL, VA', hobby: 'RAGCHEW', profession: 'RETIRED', rig: 'FTDX101', ant: 'YAGI', num: '8873' },
    { call: 'K4BCO', name: 'BECKY', qth: 'LIZELLA, GA', hobby: 'FLOWERS', profession: 'OP', rig: 'ICOM 7300', ant: 'DIPOLE', num: '8888' },
    { call: 'KJ5LXP', name: 'ELLE', qth: 'MCKINNEY, TX', hobby: 'MUSIC', profession: 'OP', rig: 'FT891', ant: 'VERTICAL', num: '5555' },
    { call: 'K2BSA', name: 'SCOUT', qth: 'CIMARRON, NM', hobby: 'SCOUTING', profession: 'LEADERSHIP', rig: 'ICOM 7300', ant: 'BEAM', num: '1910' },
    { call: 'KI7QCF', name: 'FORREST', qth: 'SPANISH FORK, UT', hobby: 'CW', profession: 'OP', rig: 'ICOM 7300', ant: 'VERTICAL', num: '7777' },
    { call: 'KB1HQS', name: 'WALT', qth: 'ALEXANDRIA, VA', hobby: 'SALT WATER OPS', profession: 'AUTHOR', rig: 'Xiegu G90', ant: 'HOMEBUILT VERTICAL ARRAY', num: '7373' },
    { call: 'K9EID', name: 'BOB', qth: 'SAINT LOUIS, MO', hobby: 'TECHNICAL', profession: 'ENGINEER', rig: 'ICOM 7610', ant: 'BEAM', num: '1980' },
    { call: 'KF8CNK', name: 'CONOR', qth: 'TOLEDO, OH', hobby: 'CW', profession: 'OP', rig: 'ICOM 7300', ant: 'VERTICAL', num: '8008' },
    { call: 'KV9L', name: 'AARON', qth: 'MOORESVILLE, IN', hobby: 'DXING', profession: 'OP', rig: 'YAESU FT891', ant: 'DIPOLE', num: '2023' },
    { call: 'WK4DS', name: 'DAVID', qth: 'TRENTON, GA', hobby: 'CW', profession: 'OP', rig: 'KENWOOD', ant: 'WIRE', num: '2024' },
    { call: 'KO4WFP', name: 'TERI', qth: 'BLOOMINGDALE, GA', hobby: 'YLS', profession: 'OP', rig: 'ICOM 7300', ant: 'DIPOLE', num: '8888' },
    { call: 'KN4MKB', name: 'BILLY', qth: 'RICHMOND, KY', hobby: 'CW', profession: 'OP', rig: 'YAESU', ant: 'VERTICAL', num: '7388' },
    { call: 'W0HT', name: 'CHAD', qth: 'ST PAUL, MN', hobby: 'CODING', profession: 'DEVELOPER', rig: 'FLEX 6400', ant: 'VERTICAL', num: '0001' }
];

export const ACTIVITY_TEMPLATES = {
    'POTA_HUNTER': [
        "{THEIR_CALL}",
        "DE {THEIR_CALL}",
        "{MY_CALL} DE {THEIR_CALL}",
        "{MY_CALL} DE {THEIR_CALL} 599 {STATE} BK",
        "TU 73 DE {THEIR_CALL}"
    ],
    'POTA_ACTIVATOR': [
        "CQ POTA DE {THEIR_CALL} K",
        "CQ POTA {THEIR_CALL} {THEIR_CALL} K",
        "{MY_CALL} DE {THEIR_CALL} UR 599 {PARK} BK",
        "QSL TNX 73 DE {THEIR_CALL} SK",
        "QRZ DE {THEIR_CALL} K"
    ],
    'SOTA_HUNTER': [
        "{THEIR_CALL}",
        "{MY_CALL} DE {THEIR_CALL} /P",
        "UR 559 {STATE} BK",
        "TNX 73 {THEIR_CALL}"
    ],
    'SOTA_ACTIVATOR': [
        "CQ SOTA DE {THEIR_CALL} {SUMMIT} K",
        "CQ SOTA {THEIR_CALL} K",
        "{MY_CALL} DE {THEIR_CALL} 559 {SUMMIT} BK",
        "QSL 73 DE {THEIR_CALL} SK"
    ],
    'WWFF_HUNTER': [
        "{THEIR_CALL}",
        "DE {THEIR_CALL} 44",
        "{MY_CALL} DE {THEIR_CALL} 599 {STATE} BK",
        "TU 73 44 {THEIR_CALL}"
    ],
    'WWFF_ACTIVATOR': [
        "CQ WWFF DE {THEIR_CALL} {WWFF_REF} K",
        "CQ WWFF {THEIR_CALL} K",
        "{MY_CALL} DE {THEIR_CALL} UR 599 {WWFF_REF} BK",
        "QSL 73 DE {THEIR_CALL} SK"
    ]
};

export const CQ_ZONES = {
    'US': [3, 4, 5],
    'CA': [1, 2, 3, 4, 5],
    'KL': [1],
    'MX': [6],
    'KP4': [8],
    'CU': [8],
    'HI': [8],
    'HT': [8],
    'BS': [8],
    'BM': [5],
    'KY': [8],
    'J3': [8], 'J6': [8], 'J7': [8], 'J8': [8], 'VP2': [8],
    'TI': [7],
    'TG': [7], 'HR': [7], 'HP': [7], 'V3': [7], 'YN': [7],
    '8P': [8], '6Y': [8],
    'BR': [11, 13],
    'AR': [13, 14],
    'CL': [12, 14],
    'CO': [9],
    'YV': [9],
    'PE': [10, 12],
    'UY': [13],
    'CP': [10, 12], 'HC': [10], 'ZP': [11], 'PZ': [9], '8R': [9],
    'FK': [13],
    'UK': [14],
    'IE': [14],
    'DE': [14],
    'FR': [14],
    'IT': [15],
    'ES': [14],
    'PT': [14],
    'NL': [14],
    'BE': [14],
    'CH': [14],
    'HB0': [14],
    'AT': [15],
    'CZ': [15],
    'SK': [15],
    'HU': [15],
    'SI': [15],
    'HR_EU': [15],
    'BA': [15],
    'RS': [15],
    'ME': [15],
    'MK': [15],
    'AL': [15],
    'GR': [20],
    'BG': [20],
    'RO': [20],
    'PL': [15],
    'SE': [14],
    'NO': [14],
    'FI': [15],
    'DK': [14],
    'IS': [40],
    'HV': [15], '3A': [14], 'T7': [15], 'C3': [15], '9H': [15], '5B': [20], 'LX': [14],
    'TR': [20],
    'RU_EU': [16],
    'RU_AS': [17, 18, 19, 23],
    'RU': [16, 17, 18, 19],
    'UA': [16],
    'BY': [16],
    'EE': [15], 'LV': [15], 'LT': [15],
    'JP': [25],
    'CN': [23, 24],
    'TW': [24],
    'HK': [24],
    'KR': [25],
    'MN': [23],
    'IN': [22],
    'PK': [21],
    'LK': [22], '8Q': [22], '9N': [22], 'A5': [22], 'S2': [22],
    'ID': [28],
    'MY': [28],
    'SG': [28],
    'TH': [26],
    'PH': [27],
    'VN': [26],
    'KH': [26], 'LA': [26],
    'IL': [20],
    'JO': [20], 'LB': [20],
    'SA': [21],
    'AE': [21], 'OM': [21], 'QA': [21], 'BH': [21], 'KW': [21],
    'GE': [21], 'AM': [21], 'AZ': [21],
    'EP': [21],
    'AU': [29, 30],
    'NZ': [32],
    'PG': [28],
    'FJ': [32], 'SB': [28], 'VU': [32], 'WS': [32], 'TO': [32],
    'KH6': [31],
    'GU': [27], 'FO': [32], 'FK_OC': [32],
    'ZA': [38],
    'EG': [34],
    'KE': [37], 'TZ': [37], 'UG': [37],
    'MA': [33], 'DZ': [33], 'TN': [33], 'LY': [34],
    'ET': [37],
    'ZM': [38], 'ZW': [38], 'BW': [38], 'NA': [38], 'MZ': [37],
    'AO': [36], 'CD': [36], 'CG': [36], 'CM': [36],
    'NG': [35], 'GH': [35], 'SN': [35], 'LR': [35],
    'MG': [39], 'MU': [39], 'SC': [39],
    'DEFAULT': 14
};

export const ITU_ZONES = {
    'US': [6, 7, 8],
    'CA': [2, 3, 4, 9, 75],
    'MX': [10],
    'KL': [1, 2],
    'KP4': [11],
    'CU': [11], 'HI': [11], 'HT': [11], 'BS': [11], 'BM': [11], 'KY': [11],
    'J3': [11], 'J6': [11], 'J7': [11], 'J8': [11], 'VP2': [11],
    'TI': [11], 'TG': [11], 'HR': [11], 'HP': [11], 'V3': [11], 'YN': [11],
    '8P': [11], '6Y': [11],
    'BR': [12, 13, 15],
    'AR': [14, 16],
    'CL': [14, 16],
    'CO': [12], 'YV': [12], 'PE': [12], 'HC': [12], 'PZ': [12], '8R': [12],
    'UY': [14], 'CP': [12, 14], 'ZP': [14],
    'FK': [16],
    'UK': [27], 'IE': [27], 'FR': [27], 'ES': [27], 'PT': [27], 'NL': [27], 'BE': [27], 'LX': [27], '3A': [27], 'C3': [27],
    'DE': [28], 'CH': [28], 'HB0': [28], 'IT': [28], 'AT': [28], 'CZ': [28], 'SK': [28], 'HU': [28], 'SI': [28], 'PL': [28],
    'HR_EU': [28], 'BA': [28], 'RS': [28], 'ME': [28], 'MK': [28], 'AL': [28],
    'GR': [28], 'BG': [28], 'RO': [28], 'TR': [39],
    'SE': [18], 'NO': [18], 'FI': [18], 'DK': [18], 'IS': [17],
    'HV': [28], 'T7': [28], '9H': [28], '5B': [39],
    'RU_EU': [29], 'UA': [29], 'BY': [29], 'EE': [29], 'LV': [29], 'LT': [29],
    'RU_AS': [30, 31, 32, 33, 34, 35],
    'JP': [45],
    'CN': [33, 42, 43, 44],
    'TW': [44], 'HK': [44], 'KR': [44], 'MN': [32, 33],
    'IN': [41], 'PK': [41], 'LK': [41], '8Q': [41], '9N': [41], 'A5': [41], 'S2': [41],
    'ID': [51, 54], 'MY': [54], 'SG': [54], 'TH': [49], 'PH': [50], 'VN': [49], 'KH': [49], 'LA': [49],
    'IL': [39], 'JO': [39], 'LB': [39], 'SA': [39], 'AE': [39], 'OM': [39], 'QA': [39], 'BH': [39], 'KW': [39],
    'GE': [29], 'AM': [29], 'AZ': [29], 'EP': [40],
    'AU': [55, 58, 59], 'NZ': [60], 'PG': [51], 'FJ': [56], 'SB': [51], 'VU': [56], 'WS': [62], 'TO': [62],
    'KH6': [61], 'GU': [27], 'FO': [63], 'FK_OC': [56],
    'ZA': [57], 'EG': [34], 'KE': [48], 'TZ': [53], 'UG': [48],
    'MA': [37], 'DZ': [37], 'TN': [37], 'LY': [34],
    'ET': [48], 'ZM': [53], 'ZW': [53], 'BW': [57], 'NA': [57], 'MZ': [53],
    'AO': [52], 'CD': [52], 'CG': [52], 'CM': [47],
    'NG': [46], 'GH': [46], 'SN': [35], 'LR': [35],
    'MG': [53], 'MU': [53], 'SC': [53],
    'DEFAULT': 27
};

export const CONTEST_TEMPLATES = {
    'CQWW_SO': [
        "CQ TEST DE {THEIR_CALL} TEST",
        "CQ TEST {THEIR_CALL} {THEIR_CALL} TEST",
        "{MY_CALL} DE {THEIR_CALL}",
        "{MY_CALL} DE {THEIR_CALL} 599 {THEIR_ZONE} BK",
        "UR 599 {MY_ZONE} BK",
        "TU {MY_CALL} DE {THEIR_CALL} TEST",
        "QSL 73 GL DE {THEIR_CALL} SK",
        "{THEIR_CALL} DE {MY_CALL} 599 {MY_ZONE}",
        "R 599 {THEIR_ZONE} TU"
    ],
    'CQWPX_CW': [
        "CQ WPX DE {THEIR_CALL} TEST",
        "CQ WPX {THEIR_CALL} {THEIR_CALL} TEST",
        "{MY_CALL} DE {THEIR_CALL}",
        "{MY_CALL} DE {THEIR_CALL} 599 {THEIR_SERIAL} BK",
        "UR 599 {MY_SERIAL} BK",
        "TU {MY_CALL} DE {THEIR_CALL} TEST",
        "QSL 73 DE {THEIR_CALL} SK",
        "{THEIR_CALL} DE {MY_CALL} 599 {MY_SERIAL}",
        "R 599 {THEIR_SERIAL} TU"
    ],
    'CWT': [
        "CQ CWT DE {THEIR_CALL} K",
        "CQ CWT {THEIR_CALL} {THEIR_CALL} K",
        "{MY_CALL} DE {THEIR_CALL}",
        "{MY_CALL} {THEIR_CALL} {THEIR_NAME} {THEIR_CWOPS}",
        "TU {MY_CALL} DE {THEIR_CALL} K",
        "QSL 73 DE {THEIR_CALL} SK"
    ],
    'IARU_HF': [
        "CQ TEST DE {THEIR_CALL} TEST",
        "CQ TEST {THEIR_CALL} {THEIR_CALL} TEST",
        "{MY_CALL} DE {THEIR_CALL}",
        "{MY_CALL} DE {THEIR_CALL} 599 {THEIR_EXCHANGE} BK",
        "UR 599 {MY_EXCHANGE} BK",
        "TU {MY_CALL} DE {THEIR_CALL} TEST",
        "QSL 73 DE {THEIR_CALL} SK"
    ],
    'ARRL_SS': [
        "CQ SS DE {THEIR_CALL} K",
        "CQ SS {THEIR_CALL} {THEIR_CALL} K",
        "{MY_CALL} DE {THEIR_CALL}",
        "{MY_CALL} DE {THEIR_CALL} {THEIR_SERIAL} {THEIR_PREC} {THEIR_CALL} {THEIR_CHECK} {THEIR_SECTION} BK",
        "{MY_SERIAL} {MY_PREC} {MY_CALL} {MY_CHECK} {MY_SECTION} BK",
        "TU {MY_CALL} DE {THEIR_CALL} K",
        "QSL 73 DE {THEIR_CALL} SK"
    ]
};

export const ARRL_SECTIONS = [
    "CT", "EMA", "ME", "NH", "RI", "VT", "WMA", "ENY", "NLI", "NNJ", "NNY", "SNJ", "WNY", "DE", "EPA", "MDC", "WPA", "AL", "GA", "KY", "NC", "NFL", "PR", "SC", "SFL", "TN", "VA", "VI", "WCF", "AR", "LA", "MS", "NM", "NTX", "OK", "STX", "WTX", "EB", "LAX", "ORG", "SB", "SCV", "SDG", "SF", "SJV", "SV", "PAC", "AZ", "EWA", "ID", "MT", "NV", "OR", "UT", "WWA", "WY", "AK", "MI", "OH", "WV", "IL", "IN", "WI", "CO", "IA", "KS", "MN", "MO", "ND", "NE", "SD", "MAR", "NL", "QC", "ONE", "ONN", "ONS", "GTA", "MB", "SK", "AB", "BC", "NT"
];

export const ARRL_PRECEDENCE = ["A", "B", "Q", "M", "U", "S"];

export const IARU_HQ_STATIONS = [
    "ARRL", "DARC", "JARL", "RAC", "RSGB", "REF", "URE", "ARI", "LABRE", "CRSA", "UBA", "VERON", "SRAL", "NRRL", "SSA", "PZK", "CRC", "MRAS", "LRMD", "ERAU"
];

export const US_STATES = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"];

export const CA_PROVINCES = ["AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT"];

export const NEIGHBORS = {
    'US': ['CA', 'MX', 'KP4', 'KL', 'XE'],
    'CA': ['US', 'KL', 'OX'],
    'UK': ['IE', 'FR', 'DE', 'NL', 'BE', 'NO'],
    'AU': ['NZ', 'PG', 'ID', 'SB', 'FK_OC'],
    'NZ': ['AU', 'FK_OC', 'TO', 'WS'],
    'JP': ['KR', 'CN', 'TW', 'RU_AS', 'HL'],
    'DE': ['PL', 'CZ', 'AT', 'CH', 'FR', 'NL', 'DK'],
    'FR': ['UK', 'BE', 'DE', 'CH', 'IT', 'ES'],
    'ES': ['PT', 'FR', 'EA8'],
    'IT': ['FR', 'CH', 'AT', 'SI', '9A'],
    'BR': ['AR', 'UY', 'PY', 'BO', 'PE', 'CO'],
    'ZA': ['ZS', 'V5', 'C9', 'A2', '7P', 'Z2'],
    'RU': ['UA', 'BY', 'KZ', 'OH', 'CN', 'MN'],
    'RU_EU': ['UA', 'BY', 'OH', 'EE', 'LV', 'LT', 'PL'],
    'RU_AS': ['CN', 'MN', 'JA', 'KL']
};

export const ITU_PREFIXES = {
    'US': ['W', 'K', 'N', 'AA-AL'],
    'CA': ['VE', 'VA', 'VO', 'VY', 'CY', 'CZ'],
    'MX': ['XA-XI', '4A-4C', '6D-6J'],
    'CU': ['CM', 'CO', 'T4'],
    'HI': ['HI'],
    'HT': ['HH', '4V'],
    'BS': ['C6'],
    'BM': ['VP9'],
    'KY': ['ZF'],
    'J3': ['J3'],
    'J6': ['J6'],
    'J7': ['J7'],
    'J8': ['J8'],
    'KP4': ['KP4', 'NP4', 'WP4'],
    'KL': ['AL', 'KL', 'NL', 'WL'],
    'TI': ['TI', 'TE'],
    'TG': ['TG', 'TD'],
    'HR': ['HR', 'HQ'],
    'HP': ['HO', 'HP'],
    'V3': ['V3'],
    'YN': ['YN', 'HT'],
    '8P': ['8P'],
    '6Y': ['6Y'],
    'VP2': ['VP2'],
    'BR': ['PP-PY', 'ZV-ZZ'],
    'AR': ['AY-AZ', 'L2-L9', 'LO-LW'],
    'CL': ['CA-CE', '3G'],
    'CO': ['HJ-HK', '5J-5K'],
    'YV': ['YV-YY', '4M'],
    'PE': ['OA-OC', '4T'],
    'UY': ['CV-CX'],
    'CP': ['CP'],
    'HC': ['HC', 'HD'],
    'ZP': ['ZP'],
    'PZ': ['PZ'],
    '8R': ['8R'],
    'FK': ['VP8'],
    'UK': ['G', 'M', '2E', '2G', '2M', '2W'],
    'DE': ['DA-DR', 'Y2-Y9'],
    'FR': ['F', 'HW-HY', 'TH', 'TM', 'TP'],
    'IT': ['I'],
    'ES': ['AM-AO', 'EA-EH'],
    'PT': ['CQ-CU'],
    'NL': ['PA-PI'],
    'BE': ['ON-OT'],
    'CH': ['HB', 'HE'],
    'HB0': ['HB0'],
    'AT': ['OE'],
    'CZ': ['OK-OL'],
    'SK': ['OM'],
    'HU': ['HA', 'HG'],
    'SI': ['S5'],
    'HR_EU': ['9A'],
    'BA': ['E7'],
    'RS': ['YU', 'YT'],
    'ME': ['4O'],
    'MK': ['Z3'],
    'AL': ['ZA'],
    'GR': ['SV-SZ', 'J4'],
    'BG': ['LZ'],
    'RO': ['YO-YR'],
    'PL': ['HF', 'SN-SR', '3Z'],
    'SE': ['SA-SM', '7S', '8S'],
    'NO': ['LA-LN', '3Y'],
    'FI': ['OF-OJ'],
    'DK': ['OU-OZ', '5P-5Q'],
    'IE': ['EI', 'EJ'],
    'IS': ['TF'],
    'RU': ['R', 'RA-RZ', 'UA-UI'],
    'UA': ['UR-UZ', 'EM-EO'],
    'BY': ['EU-EW'],
    'EE': ['ES'],
    'LV': ['YL'],
    'LT': ['LY'],
    'TR': ['TA-TC', 'YM'],
    'HV': ['HV'],
    '3A': ['3A'],
    'T7': ['T7'],
    'C3': ['C3'],
    '9H': ['9H'],
    '5B': ['5B', 'C4', 'P3'],
    'LX': ['LX'],
    'JP': ['JA-JS', '7J-7N', '8J-8N'],
    'CN': ['B', 'BA-BZ', 'VR', 'XS', '3H-3U'],
    'TW': ['BM', 'BN', 'BO', 'BP', 'BQ', 'BU', 'BV', 'BW', 'BX'],
    'HK': ['VR'],
    'KR': ['HL', 'DS', 'DT', 'D7-D9', '6K-6N'],
    'MN': ['JT', 'JU', 'JV'],
    'IN': ['AT-AW', 'VT-VW', '8T-8Y'],
    'PK': ['AP', 'AS'],
    'LK': ['4S'],
    '8Q': ['8Q'],
    '9N': ['9N'],
    'A5': ['A5'],
    'S2': ['S2', 'S3'],
    'ID': ['JZ', 'PK-PO', 'YB-YH', '7A-7I', '8A-8I'],
    'MY': ['9M', '9W'],
    'SG': ['9V', 'S6'],
    'TH': ['HS', 'E2'],
    'PH': ['DU-DZ', '4D-4I'],
    'VN': ['XV', '3W'],
    'KH': ['XU'],
    'LA': ['XW'],
    'IL': ['4X', '4Z'],
    'JO': ['JY'],
    'LB': ['OD'],
    'SA': ['HZ', '7Z', '8Z'],
    'AE': ['A6'],
    'OM': ['A4'],
    'QA': ['A7'],
    'BH': ['A9'],
    'KW': ['9K'],
    'GE': ['4L'],
    'AM': ['EK'],
    'AZ': ['4J', '4K'],
    'EP': ['EP', 'EQ'],
    'AU': ['AX', 'VH-VN', 'VZ'],
    'NZ': ['ZK-ZM'],
    'PG': ['P2'],
    'FJ': ['3D2'],
    'SB': ['H4'],
    'VU': ['YJ'],
    'WS': ['5W'],
    'TO': ['A3'],
    'KH6': ['KH6', 'KH7'],
    'GU': ['KH2'],
    'FO': ['FO'],
    'FK_OC': ['FK'],
    'ZA': ['ZR-ZU', 'S8'],
    'EG': ['SU', '6A-6B'],
    'KE': ['5Y-5Z'],
    'TZ': ['5H', '5I'],
    'UG': ['5X'],
    'MA': ['CN', '5C-5G'],
    'DZ': ['7X'],
    'TN': ['3V'],
    'LY': ['5A'],
    'ET': ['ET'],
    'ZM': ['9J'],
    'ZW': ['Z2'],
    'BW': ['A2'],
    'NA': ['V5'],
    'MZ': ['C9'],
    'AO': ['D2', 'D3'],
    'CD': ['9Q-9T'],
    'CG': ['TN'],
    'CM': ['TJ'],
    'NG': ['5N', '5O'],
    'GH': ['9G'],
    'SN': ['6W', '6V'],
    'LR': ['EL'],
    'MG': ['5R', '5S'],
    'MU': ['3B'],
    'SC': ['S7'],
    'WORLD': []
};

export const COUNTRIES = [
    { code: 'US', label: 'United States', flag: '🇺🇸' },
    { code: 'CA', label: 'Canada', flag: '🇨🇦' },
    { code: 'MX', label: 'Mexico', flag: '🇲🇽' },
    { code: 'CU', label: 'Cuba', flag: '🇨🇺' },
    { code: 'HI', label: 'Dominican Rep.', flag: '🇩🇴' },
    { code: 'HT', label: 'Haiti', flag: '🇭🇹' },
    { code: 'BS', label: 'Bahamas', flag: '🇧🇸' },
    { code: 'BM', label: 'Bermuda', flag: '🇧🇲' },
    { code: 'KY', label: 'Cayman Islands', flag: '🇰🇾' },
    { code: 'KP4', label: 'Puerto Rico', flag: '🇵🇷' },
    { code: 'KL', label: 'Alaska', flag: '🇺🇸' },
    { code: 'TI', label: 'Costa Rica', flag: '🇨🇷' },
    { code: 'HP', label: 'Panama', flag: '🇵🇦' },
    { code: '6Y', label: 'Jamaica', flag: '🇯🇲' },
    { code: 'BR', label: 'Brazil', flag: '🇧🇷' },
    { code: 'AR', label: 'Argentina', flag: '🇦🇷' },
    { code: 'CL', label: 'Chile', flag: '🇨🇱' },
    { code: 'CO', label: 'Colombia', flag: '🇨🇴' },
    { code: 'YV', label: 'Venezuela', flag: '🇻🇪' },
    { code: 'PE', label: 'Peru', flag: '🇵🇪' },
    { code: 'UY', label: 'Uruguay', flag: '🇺🇾' },
    { code: 'HC', label: 'Ecuador', flag: '🇪🇨' },
    { code: 'FK', label: 'Falkland Islands', flag: '🇫🇰' },
    { code: 'UK', label: 'United Kingdom', flag: '🇬🇧' },
    { code: 'IE', label: 'Ireland', flag: '🇮🇪' },
    { code: 'DE', label: 'Germany', flag: '🇩🇪' },
    { code: 'FR', label: 'France', flag: '🇫🇷' },
    { code: 'IT', label: 'Italy', flag: '🇮🇹' },
    { code: 'ES', label: 'Spain', flag: '🇪🇸' },
    { code: 'PT', label: 'Portugal', flag: '🇵🇹' },
    { code: 'NL', label: 'Netherlands', flag: '🇳🇱' },
    { code: 'BE', label: 'Belgium', flag: '🇧🇪' },
    { code: 'CH', label: 'Switzerland', flag: '🇨🇭' },
    { code: 'AT', label: 'Austria', flag: '🇦🇹' },
    { code: 'CZ', label: 'Czech Republic', flag: '🇨🇿' },
    { code: 'PL', label: 'Poland', flag: '🇵🇱' },
    { code: 'SE', label: 'Sweden', flag: '🇸🇪' },
    { code: 'NO', label: 'Norway', flag: '🇳🇴' },
    { code: 'FI', label: 'Finland', flag: '🇫🇮' },
    { code: 'DK', label: 'Denmark', flag: '🇩🇰' },
    { code: 'RU_EU', label: 'Russia (European)', flag: '🇷🇺' },
    { code: 'UA', label: 'Ukraine', flag: '🇺🇦' },
    { code: 'GR', label: 'Greece', flag: '🇬🇷' },
    { code: 'TR', label: 'Turkey', flag: '🇹🇷' },
    { code: 'IS', label: 'Iceland', flag: '🇮🇸' },
    { code: 'HV', label: 'Vatican City', flag: '🇻🇦' },
    { code: '3A', label: 'Monaco', flag: '🇲🇨' },
    { code: 'LX', label: 'Luxembourg', flag: '🇱🇺' },
    { code: '9H', label: 'Malta', flag: '🇲🇹' },
    { code: '5B', label: 'Cyprus', flag: '🇨🇾' },
    { code: 'RU_AS', label: 'Russia (Asiatic)', flag: '🇷🇺' },
    { code: 'JP', label: 'Japan', flag: '🇯🇵' },
    { code: 'CN', label: 'China', flag: '🇨🇳' },
    { code: 'TW', label: 'Taiwan', flag: '🇹🇼' },
    { code: 'HK', label: 'Hong Kong', flag: '🇭🇰' },
    { code: 'KR', label: 'South Korea', flag: '🇰🇷' },
    { code: 'MN', label: 'Mongolia', flag: '🇲🇳' },
    { code: 'IN', label: 'India', flag: '🇮🇳' },
    { code: 'PK', label: 'Pakistan', flag: '🇵🇰' },
    { code: 'ID', label: 'Indonesia', flag: '🇮🇩' },
    { code: 'EG', label: 'Egypt', flag: '🇪🇬' },
    { code: 'KE', label: 'Kenya', flag: '🇰🇪' },
    { code: 'MA', label: 'Morocco', flag: '🇲🇦' },
    { code: 'DZ', label: 'Algeria', flag: '🇩🇿' },
    { code: 'NG', label: 'Nigeria', flag: '🇳🇬' },
    { code: 'GH', label: 'Ghana', flag: '🇬🇭' },
    { code: 'MG', label: 'Madagascar', flag: '🇲🇬' },
    { code: 'MU', label: 'Mauritius', flag: '🇲🇺' },
    { code: 'SC', label: 'Seychelles', flag: '🇸🇨' },
    { code: 'WORLD', label: 'World (Random)', flag: '🌍' }
];

export const Q_CODES = [
    { code: 'QRG', meaning: 'What is my exact frequency?' },
    { code: 'QRK', meaning: 'What is the readability of my signals?' },
    { code: 'QRL', meaning: 'Are you busy?' },
    { code: 'QRM', meaning: 'I am being interfered with' },
    { code: 'QRN', meaning: 'I am troubled by static' },
    { code: 'QRO', meaning: 'Increase power' },
    { code: 'QRP', meaning: 'Decrease power / Low power' },
    { code: 'QRQ', meaning: 'Send faster' },
    { code: 'QRS', meaning: 'Send slower' },
    { code: 'QRT', meaning: 'Stop sending / Closing down' },
    { code: 'QRU', meaning: 'I have nothing for you' },
    { code: 'QRV', meaning: 'I am ready' },
    { code: 'QRW', meaning: 'Please tell... that I am calling him' },
    { code: 'QRX', meaning: 'Wait / Stand by' },
    { code: 'QRZ', meaning: 'Who is calling me?' },
    { code: 'QSA', meaning: 'What is the strength of my signals?' },
    { code: 'QSB', meaning: 'Your signal is fading' },
    { code: 'QSK', meaning: 'I can hear you between my signals (Full Break-in)' },
    { code: 'QSL', meaning: 'I acknowledge receipt' },
    { code: 'QSO', meaning: 'A contact / conversation' },
    { code: 'QSP', meaning: 'Will you relay to...?' },
    { code: 'QSY', meaning: 'Change frequency' },
    { code: 'QTH', meaning: 'My location is...' },
    { code: 'QTR', meaning: 'What is the time?' }
];

export const OTHER_CODES = [
    { code: '73', meaning: 'Best Regards' },
    { code: '88', meaning: 'Love and Kisses' },
    { code: 'AGN', meaning: 'Again' },
    { code: 'AR', meaning: 'End of message (+)' },
    { code: 'AS', meaning: 'Wait' },
    { code: 'BK', meaning: 'Break / Back to you' },
    { code: 'BT', meaning: 'Separator (=)' },
    { code: 'CQ', meaning: 'Calling any station' },
    { code: 'CUL', meaning: 'See you later' },
    { code: 'DE', meaning: 'From' },
    { code: 'DX', meaning: 'Long distance' },
    { code: 'ES', meaning: 'And' },
    { code: 'FB', meaning: 'Fine Business / Good' },
    { code: 'GL', meaning: 'Good luck' },
    { code: 'HI', meaning: 'Laughter' },
    { code: 'K', meaning: 'Over' },
    { code: 'KN', meaning: 'Go ahead, only you' },
    { code: 'OM', meaning: 'Old Man (Male operator)' },
    { code: 'PSE', meaning: 'Please' },
    { code: 'R', meaning: 'Received / Roger' },
    { code: 'RST', meaning: 'Readability, Signal, Tone' },
    { code: 'SK', meaning: 'End of contact' },
    { code: 'SN', meaning: 'Understood' },
    { code: 'TNX', meaning: 'Thanks' },
    { code: 'TU', meaning: 'Thank You' },
    { code: 'UR', meaning: 'Your' },
    { code: 'VA', meaning: 'End of work' },
    { code: 'WX', meaning: 'Weather' },
    { code: 'YL', meaning: 'Young Lady (Female operator)' },
    { code: 'GM', meaning: 'Good Morning' },
    { code: 'GA', meaning: 'Good Afternoon' },
    { code: 'GE', meaning: 'Good Evening' },
    { code: 'HW', meaning: 'How' },
    { code: 'OP', meaning: 'Operator' },
    { code: 'DR', meaning: 'Dear' }
];

// Backward compatibility alias for the list previously named CWOPS_MEMBERS
export const CWOPS_MEMBERS = FAMOUS_HAMS.filter(h => h.num);
